import { FC } from 'react';
import { withStyles } from 'vopay';
import styles from './Layout.module.scss';

const classes = withStyles(styles);

type LayoutProps = {
  explanation?: React.ReactNode;
  content: React.ReactNode;
};

const Layout: FC<LayoutProps> = ({ explanation, content }) => {
  return (
    <div className={classes('layoutContainer')}>
      {explanation && <div className={classes('explanation')}>{explanation}</div>}

      {content}
    </div>
  );
};

export default Layout;
